import 'css-chunksrc/client/scenes/preferences/calendar/calendarHolidays/styles.scss';export default {
  "calendarHolidaysContainer": "_calendarHolidaysContainer_rpntg_1",
  "calendarHolidaysGroup": "_calendarHolidaysGroup_rpntg_8",
  "calendarHolidaysWrapper": "_calendarHolidaysWrapper_rpntg_12",
  "activityReport": "_activityReport_rpntg_18"
};